import BaseObject from '../../../../base/base_object';
import Event from '../../../../utils/event';
import {SYSTEM_EVENTS} from '../../../../events/events';
import FreeStepMessageComponentController from '../../../../components/free_play/step_message/free_step_message_component_controller';


export default class FreePlayConfirmationGameStepDependenciesFactory extends BaseObject {
    static CLASS = 'FreePlayConfirmationGameStepDependenciesFactory';

    init(params) {
        this._serviceFactory = params.serviceFactory;
    }

    showFreePlayConfirmationMessage(gameType) {
        return new Promise((resolve, reject) => {
            let langService = this._serviceFactory.languageService();
            let messageComponent = FreeStepMessageComponentController.create();
            messageComponent.start();
            Event.fire(SYSTEM_EVENTS.MESSAGE_OPEN, {
                title: langService.translation('mdp_open_fp_message_title'),
                contentEl: messageComponent.getEl(),
                closeButton: false,
                hasDefaultButton: false,
                buttonPosition: 'center',
                customCSSClassList: ['cgp-options-component','mdp-mobile-full-size'],
                buttons: [
                    {name: langService.translation('mdp_open_fp_btn_use_now'), type: 'main', callback: () => {
                        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
                            category: 'FP_Popup',
                            action: 'FP_Button',
                            label: 'PlayFP_#' + gameType
                        });
                        resolve();
                    }},
                    {name: langService.translation('mdp_open_fp_btn_use_later'), type: 'secondary', callback: () => {
                        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
                            category: 'FP_Popup',
                            action: 'Real_Button',
                            label: 'PlayReal_#' + gameType
                        });
                        reject();
                    }},
                ],
                btnCloseCallback: () => {
                    reject();
                }
            });
        });

    }
}